import { useEffect, useMemo, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../../../redux/store';
import moment from 'moment';
import { ManualUploadInvoicesTable } from '../../invoices/ManualUploadInvoicesTable/ManualUploadInvoicesTable';
import {
  getManualUploadCustomers,
  getManualUploadInvoices,
  getManualUploadJobs,
} from '../../../../redux/services/manualUploadService';
import { InforDistSXInvoicesTable } from '../../invoices/InforDistSXInvoicesTable';
import { DistributionOneInvoicesTable } from '../../invoices/DistributionOneInvoicesTable/DistributionOneInvoicesTable';
import { Sage100InvoicesTable } from '../../invoices/Sage100InvoicesTable/Sage100InvoicesTable';
import { P21InvoicesTable } from '../../invoices/P21InvoicesTable/P21InvoicesTable';

const ManualUploadInvoices = () => {
  const dispatch = useAppDispatch();
  const { manualUploadInvoices } = useAppSelector((state) => state.manualUpload);
  const [searchText, setSearchText] = useState('');
  const { user } = useAppSelector((state) => state.auth);
  const currentSupplier = useAppSelector((state) => state.auth.currentSupplier);

  useEffect(() => {
    if (
      (user && currentSupplier?.integrationType == 'MANUAL_UPLOAD') ||
      (user && currentSupplier?.integrationType == 'ABLE_MANUAL_UPLOAD')
    ) {
      dispatch(
        getManualUploadInvoices({ itemsPerPage: 50, supplierId: currentSupplier?.id || '' })
      );
      dispatch(getManualUploadCustomers({ supplierId: currentSupplier?.id || '' }));
      dispatch(getManualUploadJobs({ supplierId: currentSupplier?.id || '' }));
    }

    return () => {};
  }, [user, currentSupplier?.id]);

  const searchedTableInvoices = useMemo(() => {
    if (manualUploadInvoices && searchText) {
      const searched = manualUploadInvoices.filter((invoice) => {
        if (
          (invoice?.id &&
            invoice?.id.toString().toLowerCase().includes(searchText.toLowerCase())) ||
          (invoice?.amount &&
            invoice?.amount.toString().toLowerCase().includes(searchText.toLowerCase())) ||
          (invoice?.terms &&
            invoice?.terms.toString().toLowerCase().includes(searchText.toLowerCase())) ||
          (invoice?.dueDate &&
            moment(invoice?.dueDate)
              .format('MM/DD/YYYY')
              .toLowerCase()
              .includes(searchText.toLowerCase())) ||
          (invoice?.createdAt &&
            moment(invoice?.createdAt)
              .format('MM/DD/YYYY')
              .toLowerCase()
              .includes(searchText.toLowerCase())) ||
          (invoice?.balance &&
            invoice?.balance.toString().toLowerCase().includes(searchText.toLowerCase()))
        ) {
          return true;
        }
        return false;
      });
      return searched;
    }

    return manualUploadInvoices;
  }, [manualUploadInvoices, searchText]);

  return (
    <div className="w-full h-full">
      <div className="flex h-full flex-col mx-10 mt-3  p-3  pb-6 rounded-lg WHITE-BG  flex-nowrap relative">
        {/* <div className="py-3 flex justify-between">
          <div className="flex items-end">
            <AppInputField
              inputFieldStyles={{ width: '300px' }}
              id="search"
              placeholder={'Search '}
              icon={<Search size={15} />}
              onTextChange={(text) => {
                setSearchText(text);
              }}
            />
          </div>
        </div> */}
        <div className="pb-3" style={{ height: '88%' }}>
          {((user && currentSupplier?.integrationType == 'MANUAL_UPLOAD') ||
            (user && currentSupplier?.integrationType == 'ABLE_MANUAL_UPLOAD')) && (
            <ManualUploadInvoicesTable invoices={searchedTableInvoices} />
          )}
          {user && currentSupplier?.integrationType == 'DISTRIBUTION_ONE' && (
            <DistributionOneInvoicesTable />
          )}
          {user && currentSupplier?.integrationType == 'SAGE_100' && <Sage100InvoicesTable />}
          {user && currentSupplier?.integrationType == 'P21' && <P21InvoicesTable />}
          {user && currentSupplier?.integrationType == 'INFOR_DIST_SX' && (
            <InforDistSXInvoicesTable />
          )}
        </div>
      </div>
    </div>
  );
};

export default ManualUploadInvoices;
